function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var registeredEvents = new Map();

var getEventKey = function getEventKey(_ref) {
  var domain = _ref.domain,
      serviceName = _ref.serviceName,
      eventName = _ref.eventName;
  return "".concat(domain, ":").concat(serviceName, ":").concat(eventName);
};

export function getListeners(path) {
  var key = getEventKey(path);
  return registeredEvents.get(key) || new Set();
}
export function addListener(_ref2) {
  var listener = _ref2.listener,
      eventPath = _objectWithoutProperties(_ref2, ["listener"]);

  var key = getEventKey(eventPath);
  var eventListeners = registeredEvents.get(key);

  if (eventListeners) {
    eventListeners.add(listener);
  } else {
    registeredEvents.set(key, new Set([listener]));
  }
}
export function removeListener(_ref3) {
  var listener = _ref3.listener,
      eventPath = _objectWithoutProperties(_ref3, ["listener"]);

  var key = getEventKey(eventPath);
  var eventListeners = registeredEvents.get(key);

  if (eventListeners) {
    eventListeners.delete(listener);
  }
}
//# sourceMappingURL=eventListeners.js.map